<div class="px-8 w-full" *ngIf="transaction$ | async as transaction">
	<ui-content-header type="page" title="Sync Data to File" />

	<div
		class="w-full rounded-xl border border-gray-200 p-8"
		*ngIf="instruction$ | async as instruction"
	>
		<div class="grid grid-cols-12 py-4 gap-4 border-b border-gray-200">
			<div class="col-span-3">
				<div>
					<h3 class="h3 mb-2">Merging</h3>
					<p class="p-sm">Select the source for each field.</p>
				</div>
			</div>
			<div class="col-span-3">
				<h4 class="h4">From Instruction</h4>
				<div class="mb-4">
					<img
						class="h-10 w-auto"
						src="/assets/images/integrations/sync-inline-logo.png"
					/>
				</div>
			</div>
			<div class="col-span-3">
				<h4 class="h4">On File</h4>
				<div class="mb-4">
					<img class="h-10 w-auto" src="/assets/images/closer-logo.svg" />
				</div>
			</div>
			<div class="col-span-3">
				<p class="h4">Resulting Data</p>
			</div>
		</div>

		<div *ngIf="vm$ | async as vm" class="py-4">
			<ng-container *ngIf="fields$ | async as fields">
				<!-- Closing Date -->
				<div class="grid grid-cols-12 py-2 gap-4" *ngIf="vm.showClosingDate">
					<div class="col-span-3 flex">
						<p class="p font-medium">Closing Date</p>
					</div>
					<div
						class="col-span-6 p-2 bg-gray-50 rounded-lg grid grid-cols-2 gap-4 cursor-pointer"
						(click)="toggleClosingDate()"
					>
						<div
							class="flex gap-4 rounded-md p-4 justify-between"
							[ngClass]="fields.closingDate ? 'bg-white' : 'bg-transparent'"
						>
							<div class="flex gap-4">
								<div
									class="rounded-full border box-content w-3 h-3 p-1"
									[ngClass]="
										fields.closingDate ? 'border-green-600' : 'border-gray-300'
									"
								>
									<div
										*ngIf="fields.closingDate"
										class="rounded-full bg-green-600 w-3 h-3"
									></div>
								</div>
								<div>
									<p class="p">{{ instruction?.closingDate | closerDate }}</p>
								</div>
							</div>
						</div>
						<div
							class="flex gap-4 rounded-md p-4 duration-300"
							[ngClass]="!fields.closingDate ? 'bg-white' : 'bg-transparent'"
						>
							<div
								class="rounded-full border box-content w-3 h-3 p-1 duration-300 shrink-0"
								[ngClass]="
									!fields.closingDate ? 'border-green-600' : 'border-gray-400'
								"
							>
								<div
									*ngIf="!fields.closingDate"
									class="rounded-full bg-green-600 w-3 h-3 duration-300"
								></div>
							</div>
							<div>
								<p
									class="p"
									[ngClass]="fields.closingDate ? '' : 'text-gray-950'"
								>
									{{ (vm.fileComparisons?.closingDate | closerDate) || '-' }}
								</p>
							</div>
						</div>
					</div>
					<div class="col-span-3 flex pt-4">
						<p class="p" *ngIf="fields.closingDate; else currentCloserDate">
							{{ instruction?.closingDate | closerDate }}
						</p>
						<ng-template #currentCloserDate>
							<p class="p">
								{{ (vm.fileComparisons?.closingDate | closerDate) || '-' }}
							</p>
						</ng-template>
					</div>
				</div>

				<!-- Purchase Price -->
				<div
					class="grid grid-cols-12 py-2 gap-4 pricedd"
					*ngIf="vm.showPurchasePrice"
				>
					<div class="col-span-3 flex pt-4">
						<p class="p font-medium">Purchase Price</p>
					</div>
					<div
						class="col-span-6 p-2 bg-gray-50 rounded-lg grid grid-cols-2 gap-4 cursor-pointer"
						(click)="togglePurchasePrice()"
					>
						<div
							class="flex gap-4 rounded-md p-4 justify-between"
							[ngClass]="fields.purchasePrice ? 'bg-white' : 'bg-transparent'"
						>
							<div class="flex gap-4">
								<div
									class="rounded-full border box-content w-3 h-3 p-1"
									[ngClass]="
										fields.purchasePrice
											? 'border-green-600'
											: 'border-gray-300'
									"
								>
									<div
										*ngIf="fields.purchasePrice"
										class="rounded-full bg-green-600 w-3 h-3"
									></div>
								</div>
								<div>
									<p class="p">
										{{ instruction?.purchasePrice | centsToDollars }}
									</p>
								</div>
							</div>
						</div>
						<div
							class="flex gap-4 rounded-md p-4 duration-300"
							[ngClass]="!fields.purchasePrice ? 'bg-white' : 'bg-transparent'"
						>
							<div
								class="rounded-full border box-content w-3 h-3 p-1 duration-300 shrink-0"
								[ngClass]="
									!fields.purchasePrice ? 'border-green-600' : 'border-gray-400'
								"
							>
								<div
									*ngIf="!fields.purchasePrice"
									class="rounded-full bg-green-600 w-3 h-3 duration-300"
								></div>
							</div>
							<div>
								<p
									class="p"
									[ngClass]="fields.purchasePrice ? '' : 'text-gray-950'"
								>
									{{ vm.fileComparisons?.purchasePrice | centsToDollars }}
								</p>
							</div>
						</div>
					</div>
					<div class="col-span-3 flex pt-4">
						<p
							class="p"
							*ngIf="fields.purchasePrice; else currentPurchasePrice"
						>
							{{ instruction?.purchasePrice | centsToDollars }}
						</p>
						<ng-template #currentPurchasePrice>
							<p class="p">
								{{ vm.fileComparisons?.purchasePrice | centsToDollars }}
							</p>
						</ng-template>
					</div>
				</div>

				<div
					class="grid grid-cols-12 py-2 gap-4 address"
					*ngIf="vm.showAddress"
				>
					<div class="col-span-3 flex pt-4">
						<p class="p font-medium">Address</p>
					</div>
					<div
						class="col-span-6 p-2 bg-gray-50 rounded-lg grid grid-cols-2 gap-4 cursor-pointer"
						(click)="toggleAddress()"
					>
						<div
							class="flex gap-4 rounded-md p-4 justify-between"
							[ngClass]="fields.address ? 'bg-white' : 'bg-transparent'"
						>
							<div class="flex gap-4">
								<div
									class="rounded-full border box-content w-3 h-3 p-1 shrink-0"
									[ngClass]="
										fields.address ? 'border-green-600' : 'border-gray-300'
									"
								>
									<div
										*ngIf="fields.address"
										class="rounded-full bg-green-600 w-3 h-3"
									></div>
								</div>
								<div>
									<ui-address
										class="[&>*>p]:uppercase"
										[address]="
											instruction?.properties[0]?.address
												| mortgageAddressConverter
										"
										type="compact"
									></ui-address>
								</div>
							</div>
						</div>
						<div
							class="flex gap-4 rounded-md p-4 duration-300"
							[ngClass]="!fields.address ? 'bg-white' : 'bg-transparent'"
						>
							<div
								class="rounded-full border box-content w-3 h-3 p-1 duration-300 shrink-0"
								[ngClass]="
									!fields.address ? 'border-green-600' : 'border-gray-400'
								"
							>
								<div
									*ngIf="!fields.address"
									class="rounded-full bg-green-600 w-3 h-3 duration-300"
								></div>
							</div>
							<div>
								<ui-address
									class="[&>*>p]:uppercase"
									[address]="vm.fileComparisons?.address"
									type="compact"
									[ngClass]="fields.address ? '' : '[&>*>p]:text-gray-950'"
								></ui-address>
							</div>
						</div>
					</div>
					<div class="col-span-3 flex pt-4">
						<ui-address
							*ngIf="fields.address; else currentAddress"
							class="[&>*>p]:uppercase"
							[address]="
								instruction?.properties[0]?.address | mortgageAddressConverter
							"
							type="compact"
						></ui-address>
						<ng-template #currentAddress>
							<ui-address
								[address]="vm.fileComparisons?.address"
								type="compact"
							></ui-address>
						</ng-template>
					</div>
				</div>

				<!-- Legal Description -->
				<div
					class="grid grid-cols-12 py-2 gap-4 descr"
					*ngIf="vm.showLegalDescription"
				>
					<div class="col-span-3 flex pt-4">
						<p class="p font-medium">Legal Description</p>
					</div>
					<div
						class="col-span-6 p-2 bg-gray-50 rounded-lg grid grid-cols-2 gap-4 cursor-pointer"
						(click)="toggleLegalDescription()"
					>
						<div
							class="flex gap-4 rounded-md p-4 justify-between"
							[ngClass]="
								fields.legalDescription ? 'bg-white' : 'bg-transparent'
							"
						>
							<div class="flex gap-4">
								<div
									class="rounded-full border box-content w-3 h-3 p-1 shrink-0"
									[ngClass]="
										fields.legalDescription
											? 'border-green-600'
											: 'border-gray-300'
									"
								>
									<div
										*ngIf="fields.legalDescription"
										class="rounded-full bg-green-600 w-3 h-3"
									></div>
								</div>
								<div>
									<p class="p">
										{{ instruction?.properties[0]?.legalDescription }}
									</p>
								</div>
							</div>
						</div>
						<div
							class="flex gap-4 rounded-md p-4 duration-300"
							[ngClass]="
								!fields.legalDescription ? 'bg-white' : 'bg-transparent'
							"
						>
							<div
								class="rounded-full border box-content w-3 h-3 p-1 duration-300 shrink-0"
								[ngClass]="
									!fields.legalDescription
										? 'border-green-600'
										: 'border-gray-400'
								"
							>
								<div
									*ngIf="!fields.legalDescription"
									class="rounded-full bg-green-600 w-3 h-3 duration-300"
								></div>
							</div>
							<div>
								<p
									class="p"
									[ngClass]="fields.legalDescription ? '' : 'text-gray-950'"
								>
									{{ vm.fileComparisons?.legalDescription || '-' }}
								</p>
							</div>
						</div>
					</div>
					<div class="col-span-3 flex pt-4">
						<p
							class="p"
							*ngIf="fields.legalDescription; else currentLegalDescription"
						>
							{{ instruction?.properties[0]?.legalDescription }}
						</p>
						<ng-template #currentLegalDescription>
							<p class="p">{{ vm.fileComparisons?.legalDescription || '-' }}</p>
						</ng-template>
					</div>
				</div>

				<ng-container *ngIf="vm.trustAccount?.accountNumber">
					<div class="grid grid-cols-12 py-2 gap-4">
						<div class="col-span-3 flex pt-4">
							<p class="p font-medium">Trust Account</p>
						</div>
						<div
							class="col-span-6 p-2 bg-gray-50 rounded-lg grid grid-cols-2 gap-4 cursor-pointer"
							(click)="toggleTrustAccount()"
						>
							<div
								class="flex gap-4 rounded-md p-4 justify-between"
								[ngClass]="
									fields.useTrustAccountOnInstructions
										? 'bg-white'
										: 'bg-transparent'
								"
							>
								<div class="flex gap-4">
									<div
										class="rounded-full border box-content w-3 h-3 p-1 shrink-0"
										[ngClass]="
											fields.useTrustAccountOnInstructions
												? 'border-green-600'
												: 'border-gray-300'
										"
									>
										<div
											*ngIf="fields.useTrustAccountOnInstructions"
											class="rounded-full bg-green-600 w-3 h-3"
										></div>
									</div>
									<div>
										<p class="p font-medium">
											{{ vm.trustAccount.institutionName }}
										</p>
										<p class="p font-medium">
											****{{ vm.trustAccount.last3DigitsAccountNumber }}
										</p>
									</div>
								</div>
							</div>
							<div
								class="flex gap-4 rounded-md p-4 duration-300"
								[ngClass]="
									!fields.useTrustAccountOnInstructions
										? 'bg-white'
										: 'bg-transparent'
								"
							>
								<div
									class="rounded-full border box-content w-3 h-3 p-1 duration-300 shrink-0"
									[ngClass]="
										!fields.useTrustAccountOnInstructions
											? 'border-green-600'
											: 'border-gray-400'
									"
								>
									<div
										*ngIf="!fields.useTrustAccountOnInstructions"
										class="rounded-full bg-green-600 w-3 h-3 duration-300"
									></div>
								</div>
								<div>
									<p class="p">Assign in file</p>
								</div>
							</div>
						</div>
						<div class="col-span-3 flex pt-4">
							<div
								*ngIf="
									fields.useTrustAccountOnInstructions;
									else noTrustAccount
								"
							>
								<p class="p font-medium">
									{{ vm.trustAccount.institutionName }}
								</p>
								<p class="p font-medium">
									****{{ vm.trustAccount.last3DigitsAccountNumber }}
								</p>
							</div>
							<ng-template #noTrustAccount>
								<p class="p">-</p>
							</ng-template>
						</div>
					</div>
				</ng-container>

				<!-- Empty State -->
				<ng-container
					*ngIf="
						!vm.showAddress &&
						!vm.showClosingDate &&
						!vm.showLegalDescription &&
						!vm.showPurchasePrice &&
						!vm.trustAccount
					"
				>
					<div class="p-sm">No fields in need of merging</div>
				</ng-container>

				<hr class="py-4 mt-8" />

				<ng-container *ngIf="vm.showMappings">
					<h3 class="h3">
						Mapping <span class="italic p-sm">(Optional)</span>
					</h3>
					<ng-container *ngFor="let client of vm.clients; trackBy: clientId">
						<div class="grid grid-cols-12 py-2 gap-4">
							<div class="col-span-3 flex items-center">
								<p class="p font-medium">
									{{ client?.guarantor ? 'Guarantor' : 'Mortgagor' }}
								</p>
							</div>
							<div class="col-span-3 flex items-center">
								<p class="p">{{ client?.name }}</p>
							</div>
							<div class="col-span-3 flex items-center gap-2">
								<p class="p">Map to:</p>
							</div>
							<div class="col-span-3">
								<app-llc-borrower-assign
									(onRemove)="onRemove(client)"
									[disabled]="false"
									[prefilledNewClient]="client.prefilledNewClient"
									[(ngModel)]="client.closerClientId"
									[signingOfficer]="false"
									(ngModelChange)="borrowerChanged($event, client)"
									[guarantor]="client.guarantor"
									[parentId]="null"
								></app-llc-borrower-assign>
							</div>
						</div>
						<div
							*ngIf="client.signingOfficer"
							class="grid grid-cols-12 py-2 gap-4"
						>
							<div class="col-span-3">
								<p class="p font-medium">Signing Officer</p>
							</div>
							<div class="col-span-3">
								<p class="p">{{ client?.signingOfficerName }}</p>
							</div>
							<div class="col-span-3 flex items-center gap-2">
								<p class="p">Map to:</p>
							</div>
							<div class="col-span-3">
								<app-llc-borrower-assign
									(onRemove)="onRemove(client, true)"
									[filterByParent]="true"
									placeholder="Select or search signing officer"
									title="Existing signing officer(s) on file"
									noResultsMessage="No signing officers found"
									[disabled]="!client.closerClientId"
									[prefilledNewClient]="client.signingOfficerPrefilledNewClient"
									[(ngModel)]="client.signingOfficerClientId"
									(ngModelChange)="borrowerChanged($event, client, true)"
									[signingOfficer]="true"
									[guarantor]="client.guarantor"
									[parentId]="client.closerClientId"
								></app-llc-borrower-assign>
							</div>
						</div>
					</ng-container>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>
